import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { modalAnatomy } from '@chakra-ui/anatomy';

const config = createMultiStyleConfigHelpers(modalAnatomy.keys);

const baseStyle = config.definePartsStyle({
  header: {
    color: 'white',
    fontFamily: 'barlow',
    fontSize: '2xl',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    _light: { color: 'black' },
  },
  dialog: {
    background: 'texas.bg.900',
    _light: { background: 'white' },
  },
  dialogContainer: {
    color: 'white',
    _light: { color: 'texas.bg.900' },
  },
  footer: {
    borderBottomRightRadius: '0.375rem',
    borderBottomLeftRadius: '0.375rem',
    bg: 'texas.bg.800',
    _light: {
      bg: 'gray.50',
    },
  },
});

const entityDirectory = config.definePartsStyle({
  header: {
    color: 'entityDirectory.text',
  },
  dialog: {
    background: 'entityDirectory.surface',
    border: '1px solid',
    borderColor: 'entityDirectory.border',
  },
  dialogContainer: {
    color: 'entityDirectory.text',
  },
  closeButton: {
    color: 'entityDirectory.text',
  },
  footer: {
    background: 'entityDirectory.raisedSurface',
    borderTop: '1px solid',
    borderColor: 'entityDirectory.border',
  },
});

export default config.defineMultiStyleConfig({
  baseStyle,
  variants: { entityDirectory },
});
